import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { AuthProvider } from 'oidc-react';
import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { setBaseUrl } from 'src/api';
import App from 'src/App';
import BackdropLoader from 'src/components/loader/BackdropLoader';
import i18next from 'src/config/i18next';
import { OIDC_CONF } from 'src/config/oidc';
import { getActiveSiteDefinition } from 'src/config/sites';
import { loadShellRuntimeConfig } from 'src/config/sites/runtimeShellConfig';
import AppMetaProvider from 'src/core/provider/AppMeta';
import { SilentSsoProvider } from 'src/core/provider/SilentSsoProvider';
import SiteProvider from 'src/core/provider/SiteProvider';
import { bootstrapProjections } from 'src/store/entities/types/projections';
import configureStore from 'src/store/store';
import AppTheme from 'src/Theme';
import * as serviceWorker from './serviceWorker';

const { store, persistor } = configureStore();
bootstrapProjections();

const renderApp = (): void => {
    ReactDOM.render(
        <>
            <I18nextProvider i18n={i18next}>
                <BrowserRouter>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            <AuthProvider {...OIDC_CONF}>
                                <SilentSsoProvider>
                                    <Suspense fallback={<BackdropLoader loading={true} />}>
                                        <AppMetaProvider>
                                            <ThemeProvider theme={AppTheme}>
                                                <SiteProvider>
                                                    <CssBaseline />
                                                    <App />
                                                </SiteProvider>
                                            </ThemeProvider>
                                        </AppMetaProvider>
                                    </Suspense>
                                </SilentSsoProvider>
                            </AuthProvider>
                        </PersistGate>
                    </Provider>
                </BrowserRouter>
            </I18nextProvider>
        </>,
        document.getElementById('root')
    );
};

void loadShellRuntimeConfig().finally(() => {
    const activeSite = getActiveSiteDefinition(window.location.hostname);
    console.log('[boot] activeSite:', activeSite.id, '| baseUrl:', activeSite.baseUrl ?? '(none)');
    if (activeSite.baseUrl) {
        setBaseUrl(activeSite.baseUrl);
    }
    renderApp();
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
